// extracted by mini-css-extract-plugin
export default {"noAccess":"NoAccess_noAccess__p4Mvz","title":"NoAccess_title__j5BHO","message":"NoAccess_message__Rdvzo"};